import {
    AfterViewInit,
    Component,
    ElementRef,
    Inject,
    OnDestroy,
    OnInit,
    ViewChild
} from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
    MAT_DIALOG_DATA,
    MatDialogRef
} from "@angular/material/dialog";
import { Client } from "app/entities";
import { ClientsService } from "app/main/pages/clients/clients.service";
import { AlertService } from "app/services/alert.service";
import { SubscriptionRestrictionService } from "app/services/subscription-restriction.service";
import { GtagService } from "app/services/gtag.service";
import { CnpjAutocompleteService } from "app/services/cnpj-autocomplete.service";
import { Subscription } from "rxjs";

@Component({
    selector: "app-create-client-dialog",
    templateUrl: "./create-client-dialog.component.html",
    styleUrls: ["./create-client-dialog.component.scss"],
})
export class CreateClientDialogComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild("clientName") clientName?: ElementRef;
    client: Client;
    mode: number; //0=full|1=compact
    form!: FormGroup;
    title!: string;
    loading = false;

    private cnpjAutocompleteSubscription?: Subscription;

    constructor(
        public matDialogRef: MatDialogRef<CreateClientDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private _formBuilder: FormBuilder,
        private _alertService: AlertService,
        private _clientsService: ClientsService,
        private _subscriptionRestrictionService: SubscriptionRestrictionService,
        private _gtag: GtagService,
        private _cnpjAutocompleteService: CnpjAutocompleteService,
    ) {
        this.client = this._data.client;
        this.mode = this._data.mode ? this._data.mode : 0;
    }
    ngAfterViewInit(): void {
        setTimeout(() => {
            this.clientName?.nativeElement.focus();
        }, 300);
    }

    ngOnDestroy(): void {
        this.cnpjAutocompleteSubscription?.unsubscribe();
    }

    ngOnInit() {

        if (this.client.id) {
            this.title = "Editar Cliente";
        } else {
            this.title = "Adicionar Cliente";
        }

        this.form = this.createForm();
        this.cnpjAutocompleteSubscription = this._cnpjAutocompleteService.watchForm(this.form, 'cpf_cnpj', {
            name: 'razao_social',
            email: 'email',
            phone: data => data.ddd_telefone_1 || data.ddd_telefone_2 || data.ddd_fax,
            address: 'logradouro',
            responsible: 'nome_fantasia',
        });

        if (this.client.contacts != null && this.client.contacts.length > 0) {
            for (var ctc of this.client.contacts) {
                this.addContact(ctc?.name!, ctc?.email!);
            }
        } else {
            this.addContact();
        }
    }

    createForm(): FormGroup {
        return this._formBuilder.group({
            id: [this.client.id, []],
            name: [this.client.name, [Validators.required]],
            email: [this.client.email, [Validators.email]],
            phone: [this.client.phone, []],
            cpf_cnpj: [this.client.cpfCnpj, []],
            address: [this.client.address, []],
            responsible: [this.client.responsible, []],
            contacts: this._formBuilder.array([]),
            image: [null, []],
        });
    }

    onAvatarChanged(event: File) {
        this.form.patchValue({
            image: event,
        });
    }

    updateUser() {
        this.form.updateValueAndValidity();
        if (this.form.valid) {
            this.loading = true;
                    this._clientsService
                        .update(this.client.id, this.form.value)
                        .subscribe(
                            (response) => {
                                this.loading = false;
                                this.trackClientEvent('client_update', response);
                                this.matDialogRef.close(response);
                            },
                            (err) => {
                                this.loading = false;
                                this._alertService.error(err);
                    }
                );
        } else {
            this._alertService.error("Preencha corretamente o formulário.");
        }
    }

    addContact(name = "", email = "") {
        const creds = this.form.controls.contacts as FormArray;
        creds.push(
            this._formBuilder.group({
                name: [name],
                email: [email],
            })
        );
    }

    contacts() {
        return this.form.controls.contacts as FormArray;
    }

    insertUser() {
        this.form.updateValueAndValidity();
        if (this.form.valid) {
                if(!this._subscriptionRestrictionService.checkFeatureLimitAndShowDialog("clientes")){
                    this.store();
                } 
        } else {
            this._alertService.error("Preencha corretamente o formulário.");
        }
    }

    store() {
        this._clientsService.store(this.form.value).subscribe(
            (response) => {
                this.loading = false;
                this.trackClientEvent('client_create', response);
                this.matDialogRef.close(response);
                this._subscriptionRestrictionService.reloadSubscriptionUsages()
            },
            (err) => {
                this.loading = false;
                this._alertService.error(err);
            }
        );
    }

    deleteUser() {}

    private trackClientEvent(eventName: 'client_create' | 'client_update', client: Client | null) {
        const formValue = this.form?.value ?? {};
        const rawDocument: string = (formValue.cpf_cnpj ?? '').toString().replace(/\D/g, '');
        const payload = {
            event_category: 'crm',
            event_label: eventName === 'client_create' ? 'Cliente criado' : 'Cliente atualizado',
            client_id: client?.id ?? formValue?.id,
            has_contacts: (client?.contacts?.length ?? formValue?.contacts?.length ?? 0) > 0,
            has_email: !!formValue.email,
            has_phone: !!formValue.phone,
            responsible: formValue.responsible ?? null,
            is_company: rawDocument.length > 11,
        };

        this._gtag.event(eventName, payload);
    }
}
